import { Button, ButtonSizes, Icon, IconSizes, Text, TextSize, TokenIcon, Tooltip } from '@rhinofi/dvf-shared-ui'
import { modalKeys } from '../../constants/modalKeys'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { useWallet } from '../../hooks/useWallet'
import { translate } from '../../intl/i18n'
import { findBridgeKeyForNetworkId } from '../../services/helperService/findBridgeKeyForNetworkId'
import { shortenAddress } from '../../services/helperService/shortenAddress'
import { showModal } from '../../store/actions/modalActions/showModal'
import { selectAddress, selectConnectedNetwork } from '../../store/selectors/user.selectors'
import { useCopyText } from '../common/Helpers/Copy'
import { FlexContainer } from '../common/Wrappers/Containers'
import { selectConfig } from '../../store/selectors/portal.selectors'

export const MenuConnectedWallets = ({ close = () => {} }: { close?: () => void }) => {
  const dispatch = useAppDispatch()

  const address = useAppSelector(selectAddress)
  const network = useAppSelector(selectConnectedNetwork)
  const wallet = useWallet()

  const bridgeConfig = useAppSelector(selectConfig)
  const primaryWalletChain = findBridgeKeyForNetworkId(network?.toString() || '', bridgeConfig || {}) || ''
  const { copyToClipboard: copyPrimary } = useCopyText({ disabled: false, text: address || '' })

  const disconnectPrimary = async () => {
    await wallet.disconnect()
    close()
  }

  if (!address) {
    return (
      <Button
        size={ButtonSizes.Large}
        onClick={() => showModal(dispatch)(modalKeys.connectWallet)}
        id="heap-connect-wallet-menu"
        fullWidth
      >
        {translate('onboarding.connect_wallet')}
      </Button>
    )
  }

  return (
    <>
      <Text size={TextSize.S} color="textSecondary" bold>
        {translate('onboarding.connected_evm_wallet')}
      </Text>
      <FlexContainer $justifyContent="space-between" $fullWidth>
        <FlexContainer $gap="8px">
          <TokenIcon token={primaryWalletChain} />
          <Text size={TextSize.S}>{shortenAddress(address, false, 8)}</Text>
        </FlexContainer>
        <FlexContainer $gap="4px">
          <Tooltip tooltipContent={translate('onboarding.copy_wallet_address')}>
            <Icon id="copy" size={IconSizes.Medium} active handleClick={copyPrimary} />
          </Tooltip>
          <Tooltip tooltipContent={translate('onboarding.disconnect_wallet')}>
            <Icon
              id="close"
              size={IconSizes.Medium}
              active
              handleClick={disconnectPrimary}
              testId="disconnect-primary-wallet-button"
            />
          </Tooltip>
        </FlexContainer>
      </FlexContainer>
    </>
  )
}
